import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mqd/volt-core/pre";
import css from "./carousel.module.css";
let CAROUSEL_ID = 0;
function generateId(id) {
  return `carousel--${id || CAROUSEL_ID++}`;
}
export function Carousel({ children, id, onActive, DoneButton }) {
  const [activeSlide, setActiveSlide] = React.useState();
  const [carouselId] = React.useState(() => generateId(id));
  const childrenRef = React.useRef([]);
  const goToSlide = React.useCallback(
    (index) => {
      if (index >= children.length)
        index = children.length - 1;
      else if (index < 0)
        index = 0;
      setActiveSlide(index);
      if (typeof onActive === "function") {
        onActive({
          slide: index,
          child: children[index],
          ref: childrenRef.current[index]
        });
      }
    },
    [children, setActiveSlide, onActive, childrenRef]
  );
  React.useEffect(() => {
    goToSlide(0);
  }, [goToSlide]);
  return /* @__PURE__ */ React.createElement("div", { className: css.carousel, id: carouselId }, /* @__PURE__ */ React.createElement("div", { className: css.slides }, React.Children.map(children, (child, i) => {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: (ref) => childrenRef.current[i] = ref,
        key: `${carouselId}__slide${i}`,
        id: `${carouselId}__slide${i}`,
        className: `${css.slide} ${activeSlide === i ? css.active : ""}`
      },
      child
    );
  })), /* @__PURE__ */ React.createElement("div", { className: css.controls }, /* @__PURE__ */ React.createElement("div", { className: css.control }, activeSlide > 0 && /* @__PURE__ */ React.createElement(
    Button,
    {
      link: true,
      style: { padding: "0" },
      onClick: () => goToSlide(activeSlide - 1)
    },
    "Back"
  )), /* @__PURE__ */ React.createElement("div", { className: css.dots }, children.map((child, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: `${carouselId}__dot${i}`,
      type: "button",
      className: `${css.dot} ${activeSlide === i ? css.active : ""}`,
      onClick: (e) => goToSlide(i, e),
      tabIndex: activeSlide === i ? -1 : 0
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: css.control }, activeSlide < children.length - 1 ? /* @__PURE__ */ React.createElement(
    Button,
    {
      link: true,
      style: { padding: "0" },
      onClick: () => goToSlide(activeSlide + 1)
    },
    "Next"
  ) : DoneButton)));
}
Carousel.propTypes = {
  DoneButton: PropTypes.node,
  children: PropTypes.any,
  id: PropTypes.string,
  onActive: PropTypes.func
};
Carousel.defaultProps = {
  DoneButton: null
};
